import { useQuery } from "@apollo/client"
import { get } from "lodash-es"
import { useSelector } from "react-redux"
import {
  ASSIGNED_TRIPS_LIST,
  ASSIGNED_TRIPS_MAP,
} from "graphql/trip/trip.queries.gql"
import useAuth from "hooks/useAuth"
import { useCurrentDcId } from "store/auth.redux"
import { PAGE_SIZE } from "store/vehicle.redux"
import { getId, validKeys } from "utils/custom.utils"

/*
  This query populates the assigned trips in the general MAP of vehicle module
  It doesnt have pagination since all the trips need to be shown in the map
*/
export function useAssignedTripsMapVariables() {
  const { user } = useAuth()
  const distributionCentreId = useCurrentDcId()
  const date = useSelector(state => state.vehicle.selectedDate)
  const filter = useSelector(state => state.vehicle.filter)
  const search = useSelector(state => state.vehicle.search)
  function getSkuRange(range) {
    let rangeValue
    Object.keys(range).forEach(key => {
      if (range[key].selected) {
        rangeValue = get(filter, `skuRange.${key}.value`, [])
      }
    })
    return rangeValue
  }
  return {
    departmentId: user?.currentDepartment?.id,
    date,
    query: search,
    filter: {
      tripCount: validKeys(filter.tripCount)?.[0],
      tripStatus: validKeys(filter.status),
      distributionCentreId,
      skuStatus: getSkuRange(filter.skuRange),
      varieties: filter?.varieties?.map?.(v => getId(v)),
    },
  }
}
export function useAssignedTripsMap() {
  const variables = useAssignedTripsMapVariables()

  const { data, loading, error } = useQuery(ASSIGNED_TRIPS_MAP, {
    variables,
  })
  return { loading, error, trips: data?.assignedVehiclesTrips ?? [] }
}

/*
  This query populates the assigned trips in the general TABLE view of vehicle module
  It does have pagination since the user can sort,search and retreive as much data as he wants
*/
export function useAssignedTripsListVariables() {
  const { user } = useAuth()
  const distributionCentreId = useCurrentDcId()
  const date = useSelector(state => state.vehicle.selectedDate)
  const filter = useSelector(state => state.vehicle.filter)
  const search = useSelector(state => state.vehicle.search)
  const page = useSelector(state => state.vehicle.page)
  function getSkuRange(range) {
    let rangeValue
    Object.keys(range).forEach(key => {
      if (range[key].selected) {
        rangeValue = get(filter, `skuRange.${key}.value`, [])
      }
    })
    return rangeValue
  }
  return {
    departmentId: user?.currentDepartment?.id,
    date,
    query: search,
    first: PAGE_SIZE,
    skip: page * PAGE_SIZE,
    filter: {
      tripCount: validKeys(filter.tripCount)?.[0],
      distributionCentreId,
      tripStatus: validKeys(filter.status),
      skuStatus: getSkuRange(filter.skuRange),
      varieties: filter?.varieties?.map?.(v => getId(v)),
    },
  }
}

export function useAssignedTripsList() {
  // const [{ date }] = useSearchFilter();
  const variables = useAssignedTripsListVariables()
  const { data, loading, error } = useQuery(ASSIGNED_TRIPS_LIST, {
    variables,
  })
  return { loading, error, trips: data?.assignedVehiclesTrips ?? [] }
}
